import { render, staticRenderFns } from "./RequestBook.vue?vue&type=template&id=65521c4b&"
import script from "./RequestBook.vue?vue&type=script&lang=js&"
export * from "./RequestBook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports